class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this._loading = false;
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      rootMargin: '900px 0px',
      threshold: 0.01
    });
    this.observer.observe(this);
    this.addEventListener('click', this.onClickHandler.bind(this));
    this._fallbackScroll = this.checkNearViewport.bind(this);
    window.addEventListener('scroll', this._fallbackScroll, { passive: true });
    window.addEventListener('resize', this._fallbackScroll, { passive: true });
    setTimeout(this._fallbackScroll, 250);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this._fallbackScroll) {
      window.removeEventListener('scroll', this._fallbackScroll);
      window.removeEventListener('resize', this._fallbackScroll);
    }
  }

  checkNearViewport() {
    if (this._loading || this.classList.contains('loading') || this.classList.contains('disabled')) return;
    const rect = this.getBoundingClientRect();
    if (rect.top < window.innerHeight + 900 && rect.bottom > -200) {
      this.onClickHandler();
    }
  }

  onClickHandler(event) {
    if (event && event.preventDefault) event.preventDefault();
    if (this._loading || this.classList.contains('loading') || this.classList.contains('disabled')) return;
    const url = this.dataset.url;
    if (!url) return;
    this._loading = true;
    this.classList.add('loading', 'disabled');
    InfiniteScroll.renderSectionFetch(url).catch(e => {
      console.error(e);
      this.classList.remove('loading', 'disabled');
      this._loading = false;
    });
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) this.onClickHandler();
    });
  }

  static getSections() {
    const grid = document.getElementById('product-card-grid');
    return [{ section: grid && grid.dataset ? grid.dataset.id : null }];
  }

  static renderSectionFetch(url) {
    return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        InfiniteScroll.renderPagination(responseText);
        InfiniteScroll.renderProductGridContainer(responseText);
      });
  }

  static renderPagination(html) {
    const current = document.getElementById('products-container');
    const container = current && current.querySelector('.pagination-container');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextProducts = parsed.getElementById('products-container');
    const pagination = nextProducts && nextProducts.querySelector('.pagination-container');
    if (!container) return;
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    } else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const productsContainer = document.getElementById('product-card-grid');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const products = parsed.getElementById('product-card-grid');
    if (productsContainer && products) {
      productsContainer.insertAdjacentHTML('beforeend', products.innerHTML);
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
